"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ts_validators_1 = require("ts-validators");
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const PickerViewRenderer_1 = __importDefault(require("../PickerViewRenderer"));
const useControlEvents_1 = __importDefault(require("../../../hooks/useControlEvents"));
const controlStyleToAtomStyle_1 = __importDefault(require("../../../shared/controlStyleToAtomStyle"));
const PickerRenderer = ({ pickerControl }) => {
    var _a;
    const { Render, functions: { processor }, getColorFromSpecification, globalFontSize, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const events = (0, useControlEvents_1.default)(pickerControl);
    (0, useOnLoad_1.default)(pickerControl, events);
    const { searchEnabled = false, propValue = 'value', propLabel = 'label', value, defaultValue, items = {}, placeHolder = 'Select a value', arrowsEnabled = false, } = pickerControl;
    const formatedItems = (0, react_1.useMemo)(() => Object.values(items).map((item) => ({
        label: `${item[propLabel]}`,
        value: `${item[propValue]}`,
    })), [items, propValue, propLabel]);
    (0, react_1.useEffect)(() => {
        if (value || !defaultValue || !formatedItems.length) {
            return;
        }
        const defaultItem = formatedItems.find((item) => (item.value === defaultValue));
        if (!defaultItem) {
            return;
        }
        processor.root.updateControlById({
            control: pickerControl,
            dataToUpdate: {
                value: defaultItem.value,
                label: defaultItem.label,
            },
        });
    }, [formatedItems, defaultValue, value, processor, pickerControl]);
    const selectedValue = (0, react_1.useMemo)(() => {
        if ((0, ts_validators_1.valueIsString)(value) || (0, ts_validators_1.valueIsNumber)(value)) {
            return `${value}`;
        }
        return defaultValue;
    }, [value, defaultValue]);
    const onChangeValue = (0, react_1.useCallback)((newValue) => {
        if (selectedValue === newValue || !formatedItems.length) {
            return;
        }
        const newItem = formatedItems.find((item) => item.value === newValue);
        if (!newItem) {
            return;
        }
        if (events.onChange) {
            events.onChange(newItem.value);
        }
        processor.root.updateControlById({
            control: pickerControl,
            dataToUpdate: {
                value: newItem.value,
                label: newItem.label,
            },
        });
    }, [formatedItems, selectedValue, processor, pickerControl, events]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        searchEnabled && (react_1.default.createElement(PickerViewRenderer_1.default, { pickerControl: pickerControl, value: selectedValue, items: formatedItems, placeholder: placeHolder, arrowsEnabled: arrowsEnabled, searchEnabled: searchEnabled, onChange: onChangeValue })),
        !searchEnabled && (react_1.default.createElement(Render.PickerView, { value: selectedValue, items: formatedItems, placeholder: placeHolder, style: (0, controlStyleToAtomStyle_1.default)({
                getColorFromSpecification,
                globalFontSize,
                style: (_a = pickerControl.style) !== null && _a !== void 0 ? _a : {},
            }), arrowsEnabled: arrowsEnabled, onChange: onChangeValue }))));
};
exports.default = PickerRenderer;
